import * as React from 'react';
import { AutoCompleteAsync } from 'sha-el-design';
import Api from 'requestapijs';
import { Omit } from 'sha-el-design/lib/helpers';
import { questionDropdownQuery } from './constant';
import { QuestionNodeEdge, QuestionNodeConnection } from '../../../../schema';
import { API_URL, HEADER } from '../../../config';
import { AutoCompleteAsyncProps } from 'sha-el-design/lib/components/AutoComplete/AutoCompleteAsync';

export class QuestionDropdown extends React.Component<Props, {}> {
  static defaultProps = {
    extrafields: [],
  };

  constructor(props) {
    super(props);
  }

  fetch = (name: string) =>
    new Promise<QuestionNodeEdge[]>((resolve, reject) => {
      Api.graphql<{ name: string }, { data: { allQuestions: QuestionNodeConnection } }>(
        API_URL,
        { name },
        questionDropdownQuery,
        HEADER,
        (v) => resolve(v.data.allQuestions.edges),
        (e) => reject(e),
      );
    })

  render() {
    return (
      <AutoCompleteAsync<QuestionNodeEdge>
        {...this.props}
        mode='multiple'
        data={(v) => this.fetch(v)}
        inputProps={{
          ...this.props.inputProps,
        }}
        filterFunction={() => true}
      />
    );
  }
}

interface Props extends Omit<AutoCompleteAsyncProps<QuestionNodeEdge>, 'data'> {
  mode: 'multiple';
  value: QuestionNodeEdge[];
  onChange: (value: QuestionNodeEdge[]) => void;
}
